module finadai.app.admin.find_negotiation {
    import ProxyRecord = models.http.responses.ProxyRecord;
    export var NAME = "finadai.app.admin.find_negotiation"

    function AdminFindNegotiationController(customersService: services.CustomersService,
                                            whoIAm: models.User, $rootScope, $scope,
                                            notify, confirm, $mdDialog: ng.material.IDialogService,
                                            $state: ng.ui.IStateService, negotiationsService: services.NegotiationsService,
                                            proxifier, $q: ng.IQService, authService: services.AuthService) {
        $scope.formData = {};
        $scope.findNegotiationComplete = false;
        $scope.findNegotiationInProgress = false;
        $scope.sendingNegotiation = false;
        $scope.messageCustomer = "";

        let msgCustomer = "";
        $scope.canfindNegotiation = whoIAm.operations.indexOf('admin_find_negotiation') >= 0;
        $scope.searchFindNegotiationData = (form) => {
            if (form.$valid) {
                $scope.findNegotiationComplete = false;
                $scope.findNegotiationInProgress = true;
                let $negotiation_info = "";
                customersService.proxySearchNegotiation({customer_number: $scope.formData.customer_number})
                    .then(function (response) {
                        angular.forEach(response.data, function (value, key) {
                            $negotiation_info += $scope.displayFields(value);
                        });
                        $negotiation_info += "<ul><li>Detalle</li></ul>";
                        angular.forEach(response.data.Data.Detalle, function (value, key) {
                            $negotiation_info += $scope.displayFields(value);
                        });
                        $scope.messageCustomer = $negotiation_info;
                        $scope.findNegotiationInProgress = false;
                        $scope.findNegotiationComplete = true;

                    }, function () {
                        $scope.findNegotiationInProgress = false;
                    });
            }
        };
        $scope.displayFields = (value) => {
            var output = '<ul>';
            angular.forEach(value, (value, key: string | number) => {
                const normalizedKey = key != null ? key.toString() : '';
                if (normalizedKey !== "Detalle" && typeof value === "object") {
                    output += $scope.displayFields(value);
                } else if (normalizedKey !== "Detalle") {
                    output += '<li>' + normalizedKey + ": " + value + '</li>';
                }
            });
            output += '</ul>';
            output += '<hr />';
            return output
        }
    };

    export function run() {
        var search = angular.module(NAME, [])
        search.controller("AdminFindNegotiationController", AdminFindNegotiationController)
    }
}
finadai.app.admin.find_negotiation.run();
